<template>
  <div id="app" :class="{ 'menu-open': $root.menuOpen }">
    <MainHeader v-if="this.$root.headerIsVisible" />
    <router-view :key="$route.path"></router-view>
    <MainFooter />
  </div>
</template>

<script>
import MainHeader from "./components/MainHeader";
import MainFooter from "./components/MainFooter";
export default {
  name: "app",
  data() {
    return {};
  },
  components: {
    MainHeader,
    MainFooter,
  },
  created: function () {},
  mounted: function () {
    this.fetchData();
  },
  methods: {
    fetchData: function () {
      var self = this;
      $.get(
        self.$root.apiUrl + "wp-json/wp/v2/page_components?slug=favicon",
        function (response) {
          self.setIcon(response[0].acf.favicon);
        }
      )
        .done(function () {})
        .fail(function () {});
    },
    setIcon: function (icon) {
      var link = document.querySelector("link[rel*='icon']");
      icon === undefined ? "../static/img/favicon.png" : (link.href = icon);
    },
  },
};
</script>

<style lang="scss">
@import "./assets/scss/main.scss";
</style>



// WEBPACK FOOTER //
// App.vue?7a76ade1